import { render, staticRenderFns } from "./NotificationChip.vue?vue&type=template&id=6ec5d688&scoped=true&"
var script = {}
import style0 from "./NotificationChip.vue?vue&type=style&index=0&id=6ec5d688&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec5d688",
  null
  
)

export default component.exports